import { useState } from 'react';
import { useDeepCompareEffect } from 'react-use';
import { DevicesStatesFiltersFields } from 'models';

// components
import { CustomIdSelect, IncidentErrorTypeSelect, IncidentReasonSelect, SeverityTypeSelect } from 'components/Controls';
import GroupedFilters from 'components/Controls/GroupedFilters/GroupedFiltersComponent';
import { FilterButton } from 'components/Buttons';

// styles
import useStyles from 'styles/filters';

interface Props {
  isLoading: boolean;
  filter: DevicesStatesFiltersFields;
  updateFilter: (filters?: DevicesStatesFiltersFields) => void;
}

const DeviceStatesTableFilter = ({
  updateFilter,
  isLoading,
  filter
}: Props): JSX.Element => {
  const classes = useStyles();
  const [state, setState] = useState(filter);

  useDeepCompareEffect(() => {
    setState(filter);
  }, [filter]);

  const handleSelectOwner = (owner: number | undefined) => setState({ ...state, owner: Number(owner) || undefined });
  const handleSelectProjects = (projects: number[]) => setState(prevState => ({ ...prevState, projects }));
  const handleSelectZones = (zones: number[]) => setState(prevState => ({ ...prevState, zones }));
  const uncheckGroups = () => setState({ ...state, groups: [] });
  const handleSelectGroups = (groups: number[]) => setState({ ...state, groups });

  const onSave = () => { updateFilter(state); };
  const onReset = () => { updateFilter(); };

  return (
    <FilterButton
      isLoading={ isLoading }
      filter={filter}
      onSave={onSave}
      onReset={onReset}
    >
      <div className={ classes.gridRoot }>
        <GroupedFilters
          handleSelectOwner={ handleSelectOwner }
          owner={ state.owner }
          projects={ state.projects }
          handleSelectProjects={ handleSelectProjects }
          zones={ state.zones }
          handleSelectZones={ handleSelectZones }
          uncheckGroups={ uncheckGroups }
          groups={ state.groups }
          handleSelectGroups={ handleSelectGroups }
          isProjectShow
          isZoneShow
          isGroupsShow
        />
        <CustomIdSelect
          selected={ state.devices }
          changeHandler={ devices => setState({ ...state, devices }) }
          name="Device"
          type="hex"
        />
        <IncidentErrorTypeSelect
          isMulti
          isClearable
          label="Error Types"
          schema="deviceState"
          selected={ state.incidentTypes }
          onChange={ incidentTypes => setState({ ...state, incidentTypes }) }
        />
        <IncidentReasonSelect
          isMulti
          isClearable
          label="Reasons"
          schema="deviceState"
          selected={ state.reason ?? [] }
          onChange={ reason => setState({ ...state, reason }) }
        />
        <SeverityTypeSelect
          isMulti
          isClearable
          selected={ state.severity }
          onChange={ severity => setState({ ...state, severity }) }
        />
      </div>
    </FilterButton>
  );
};

export default DeviceStatesTableFilter;
